import React from "react";
import "./styles/Navigation.css";
import { NavLink } from "react-router-dom";
import {
  SideNav,
  SideNavItem,
  Button,
  Navbar,
  NavItem
} from "react-materialize";

import AuthUserContext from "./AuthUserContext";
import SignOutButton from "./SignOut";
import * as routes from "../constants/routes";

const Navigation = () => (
  <AuthUserContext.Consumer>
    {authUser => (authUser ? <NavigationAuth /> : <NavigationNonAuth />)}
  </AuthUserContext.Consumer>
);

const NavigationAuth = () => (
  <div className="sidebar">
    <ul>
      <li>
        <NavLink to={routes.LANDING} activeClassName="navlink-selected" exact>
          Landing
        </NavLink>
      </li>
      <li>
        <NavLink to={routes.HOME} activeClassName="navlink-selected" exact>
          Home
        </NavLink>
      </li>
      <li>
        <NavLink to={routes.ACCOUNT} activeClassName="navlink-selected" exact>
          Account
        </NavLink>
      </li>
      <li>
        <NavLink to={routes.SIDENAV} activeClassName="navlink-selected" exact>
          Sidenav
        </NavLink>
      </li>
      <li>
        <SignOutButton />
      </li>
    </ul>
  </div>
);


const NavigationNonAuth = () => (
  <ul>
    <li>
      <NavLink to={routes.LANDING}>Landing</NavLink>
    </li>
    <li>
      <NavLink to={routes.SIGN_IN}>Sign In</NavLink>
    </li>
  </ul>
);

export default Navigation;
